import { Injectable } from "@angular/core";

import { ApiTemplate } from "../base/template/api.template";
import { License, LicenseRequest } from "./model/license.model";

@Injectable({ providedIn: 'root' })
export class LicenseApi extends ApiTemplate<License, LicenseRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/licenses");
    }
}
